let pendingMessagingPeerUserId: string | null = null;
let pendingMessagingCompose = false;

export function takePendingMessagingPeerUserId(): string | null {
  const value = pendingMessagingPeerUserId;
  pendingMessagingPeerUserId = null;
  return value;
}

export function setPendingMessagingPeerUserId(peerUserId: string | null | undefined): void {
  const trimmed = peerUserId?.trim() || null;
  pendingMessagingPeerUserId = trimmed;
}

export function peekPendingMessagingPeerUserId(): string | null {
  return pendingMessagingPeerUserId;
}

export function setPendingMessagingCompose(open: boolean): void {
  pendingMessagingCompose = open;
}

export function takePendingMessagingCompose(): boolean {
  const value = pendingMessagingCompose;
  pendingMessagingCompose = false;
  return value;
}
